/**
 * Create by zhijie.huang on 2018/9/29
 * validate 校验配置
 */
import i18n from '@/lang/zh-validate'
import baseCheck from '@/utils/baseCheck'

const base = {
  required: true,
  trigger: 'blur',
  whilespace: false
}

const validataObj = {
  common: {
    notEmpty: {
      ...base,
      message: i18n.validate.notEmpty
    },
    isMobile: {
      ...base,
      pattern: baseCheck.pattern.isMobile,
      message: i18n.validate.isMobile
    },
    isIP: {
      ...base,
      pattern: baseCheck.pattern.isIP,
      message: i18n.validate.isIP
    },
    isMail: {
      ...base,
      pattern: baseCheck.pattern.isMail,
      message: i18n.validate.isMail
    },
    isAmount: {
      ...base,
      pattern: baseCheck.pattern.isAmount,
      message: i18n.validate.isAmount
    }
  },
  site: {
    name: {
      ...base,
      message: i18n.validate.notEmpty
    }
  },
  login: {
    username: {
      ...base,
      message: i18n.validate.username
    },
    password: {
      ...base,
      message: i18n.validate.password
    }
  }
}

export default validataObj
